<app-loading-bar></app-loading-bar>
@if (mostrarCargando) {
  <app-loading [message]="mensajeCargando"></app-loading>
}

<mat-sidenav-container class="content-gris">
  <mat-sidenav #sidenav fixedInViewport autosize class="sidenav"
    [ngClass]="{'superadmin': sessionData.isSuperAdmin, 'admin': !sessionData.isSuperAdmin}" mode="side"
    [opened]="true">
    @if (loadingMenu) {
      <app-loader [message]="'Cargando menú'"></app-loader>
    }
    <span style="margin-left: 50px;"><!--a class="home" (click)="sidenavRight.close()" routerLink="/dash"-->
      <a class="home" routerLink="/">
        @if (!imagenRota) {
          <img [src]="logo" class="img-toolbar"
            (error)="manejarErrorImagen()"
            (load)="onImagenCargada()"
            />
        }
        @if (imagenRota) {
          <div>
            <img [src]="logoDefault" class="img-toolbar" />
          </div>
        }
      </a>
    </span>
    @if (!loadingMenu) {
      <mat-nav-list class="nav-kobra" #menuList>
        <mat-accordion [multi]="true">
          @for (item of menuItems; track item) {
            @if (!item.banExpandible && item.banVisible) {
              <div>
                <a mat-list-item [routerLink]="item.txtUrl" [queryParams]="item.txtQueryParams" class="item-menu-padre"
                  routerLinkActive="active-link"
                  (click)="registrarClickMenu(item.txtNomMenu)">
                  <mat-icon class="icono-menu"
                  [ngClass]="{'superadmin': sessionData.isSuperAdmin, 'admin': !sessionData.isSuperAdmin}">{{item.txtIcono}}</mat-icon>
                  <span class="item-padre" [ngClass]="{'superadmin': sessionData.isSuperAdmin}">{{item.txtNomMenu}}</span>
                </a>
              </div>
            }
            @if (item.banExpandible) {
              <mat-expansion-panel [expanded]="item.banExpandir" class="sin-border"
                [ngClass]="{'superadmin': sessionData.isSuperAdmin, 'admin': !sessionData.isSuperAdmin}">
                <mat-expansion-panel-header style="font-size: larger;"
                  [ngClass]="{'indicador-blanco': sessionData.isSuperAdmin}">
                  {{item.txtNomMenu}}
                </mat-expansion-panel-header>
                @if (item.menuHijos.length>0) {
                  <div style="margin-left: -20px;">
                    <div>
                      <mat-nav-list class="nav-kobra-item">
                        @for (itemHijo of item.menuHijos; track itemHijo; let i = $index) {
                          @if (itemHijo.banVisible) {
                            <a mat-list-item class="item-menu" [routerLink]="itemHijo.txtUrl"
                              routerLinkActive="active-link"
                              (click)="registrarClickMenu(item.txtNomMenu, itemHijo.txtNomMenu)">
                              <mat-icon class="icono-menu"
                              [ngClass]="{'superadmin': sessionData.isSuperAdmin, 'admin': !sessionData.isSuperAdmin}">{{itemHijo.txtIcono}}</mat-icon>
                              <span class="item-wrap"
                              [ngClass]="{'superadmin': sessionData.isSuperAdmin }">{{itemHijo.txtNomMenu}}</span>
                            </a>
                          }
                        }
                      </mat-nav-list>
                    </div>
                  </div>
                }
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
        <!--ng-container *ngFor="let item of menuItems">
        <div *ngIf="(!item.menu || item.menu.length == 0) && item.visible">
          <a mat-list-item [routerLink]="item.url" [queryParams]="item.queryParams" routerLinkActive="active-link" >
            <mat-icon>{{item.icono}}</mat-icon>
            <span class="item-padre">{{item.nombre}}</span>
          </a>
        </div>
        <div *ngIf="item.menu.length>0">
          <div>
            <a mat-list-item><b>{{item.nombre}}</b></a>
            <div>
              <mat-nav-list class="nav-kobra-item">
                <ng-container *ngFor="let itemHijo of item.menu; index as i">
                  <a mat-list-item class="item-menu" *ngIf="itemHijo.visible" [routerLink]="itemHijo.url" routerLinkActive="active-link">
                    <mat-icon>{{itemHijo.icono}}</mat-icon>
                    <span class="item-wrap">{{itemHijo.nombre}}</span>
                  </a>
                </ng-container>
              </mat-nav-list>
            </div>
          </div>
        </div>
      </ng-container-->
    </mat-nav-list>
  }
</mat-sidenav>

<mat-sidenav-content>
  <mat-toolbar class="header toolbar" #toolbar>
    <mat-toolbar-row>
      <button mat-icon-button (click)="sidenav.toggle(); sideAbierto=!sideAbierto"
        style="color: black; margin-left: -15px">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"
          class="eva eva-menu-2-outline" fill="currentColor">
          <g data-name="Layer 2">
            <g data-name="menu-2">
              <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0"></rect>
              <circle cx="4" cy="12" r="1"></circle>
              <rect x="7" y="11" width="14" height="2" rx=".94" ry=".94"></rect>
              <rect x="3" y="16" width="18" height="2" rx=".94" ry=".94"></rect>
              <rect x="3" y="6" width="18" height="2" rx=".94" ry=".94"></rect>
            </g>
          </g>
        </svg>
      </button>

      <breadcrumb [tamanioGrande]="tamanioGrande">
    </breadcrumb>
    <span class="flex-spacer"></span>


    @if (tamanioGrande) {
      <div class="toolbar-right">
        @if (isSuperAdmin) {
          <a class="ui dropdown item" style="margin-right:10px; color:black;"
            [matMenuTriggerFor]="menuPaises">
            <img [src]="paisActual.img" style="height: 15px;" />
            <span class="nombre" style="font-size: 15px;"> {{paisActual.nombre}}</span>
            <mat-icon class="header-arrow-down">keyboard_arrow_down</mat-icon>
          </a>
        }
        @if (!isSuperAdmin) {
          <a class="ui dropdown item" style="margin-right:10px; color:black;">
            <img [src]="paisActual.img" style="height: 15px;" />
            <span class="nombre" style="font-size: 15px;"> {{paisActual.nombre}}</span>
          </a>
        }
        <div class="notification-bell" [matMenuTriggerFor]="menuNotificaciones" matTooltip="Notificaciones" mat-tooltip-panel-above>
          <mat-icon [ngClass]="{'vibrating-icon': unreadNotifications > 0}">notifications</mat-icon>
          @if (unreadNotifications > 0) {
            <span class="notification-dot">{{ unreadNotifications }}</span>
          }
        </div>
        @if (isSuperAdmin) {
          <div class="apps-menu" [matMenuTriggerFor]="menuApps" matTooltip="Aplicaciones" mat-tooltip-panel-above>
            <mat-icon>apps</mat-icon>
          </div>
        }
        <div [matMenuTriggerFor]="menu">
          <button mat-icon-button class="usuario" matTooltip="{{user.admin ? user.admin.nombre:''}}"
            mat-tooltip-panel-above>
            <mat-icon class="header-arrow-down">account_circle</mat-icon>
          </button>
          <mat-label style="cursor:pointer">{{user.admin ? user.admin.nombre.trim():''}}</mat-label>
        </div>
      </div>
    }
    @if (!tamanioGrande) {
      <div>
        <mat-icon class="header-arrow-down"  matTooltip="Opciones" mat-tooltip-panel-above
          [matMenuTriggerFor]="menuOpciones">
          keyboard_arrow_down
        </mat-icon>
        @if (unreadNotifications > 0) {
          <span class="notification-dot-tamanio-chico">{{ unreadNotifications }}</span>
        }
      </div>
    }
  </mat-toolbar-row>
  <mat-menu #menu="matMenu">
    <button mat-menu-item [routerLink]="['/user']">Editar perfil <mat-icon>account_circle</mat-icon></button>
    <button mat-menu-item (click)="cerrarSesion()">Cerrar sesión <mat-icon>logout</mat-icon></button>
  </mat-menu>

  <mat-menu #menuOpciones="matMenu">
    @if (isSuperAdmin) {
      <button mat-menu-item (click)="$event.stopPropagation()" [matMenuTriggerFor]="menuPaises">
        <a class="ui dropdown item" style="margin-right:10px; color:black;">
          <img [src]="paisActual.img" style="height: 15px;" />
          <span class="nombre" style="font-size: 15px;"> {{paisActual.nombre}}</span>
        </a>
        <mat-icon [hidden]="!isSuperAdmin">keyboard_arrow_down</mat-icon>
      </button>
    }

    @if (!isSuperAdmin) {
      <button mat-menu-item (click)="$event.stopPropagation()">
        <a class="ui dropdown item" style="margin-right:10px; color:black;">
          <img [src]="paisActual.img" style="height: 15px;" />
          <span class="nombre" style="font-size: 15px;"> {{paisActual.nombre}}</span>
        </a>
      </button>
    }

    <button mat-menu-item (click)="$event.stopPropagation()" [matMenuTriggerFor]="menuNotificaciones">
      Notificaciones
      <mat-icon [ngClass]="{'vibrating-icon': unreadNotifications > 0}">notifications</mat-icon>
      @if (unreadNotifications > 0) {
        <span class="notification-dot-menu">{{ unreadNotifications }}</span>
      }
    </button>

    @if (isSuperAdmin) {
      <button mat-menu-item (click)="$event.stopPropagation()" [matMenuTriggerFor]="menuApps">
        Aplicaciones
        <mat-icon>apps</mat-icon>
      </button>
    }

    <button mat-menu-item [routerLink]="'/user'">Editar perfil <mat-icon>account_circle</mat-icon></button>

    <button mat-menu-item (click)="cerrarSesion()">Cerrar sesión <mat-icon>logout</mat-icon></button>
  </mat-menu>
  <mat-menu #menuPaises="matMenu">
    @for (pais of filtrarPaises(); track pais) {
      <button mat-menu-item (click)="cambioPais(pais)"><img [src]="pais.img"
      style="height: 15px;" /> {{pais.nombre}}</button>
    }
  </mat-menu>

  <mat-menu #menuNotificaciones="matMenu" class="custom-menu">
    <div class="notificacion-div">
      <h3 style="margin: 0px;">Notificaciones</h3>
      @if (notifications.length > 0) {
        <button mat-button (click)="markAllNotificationsAsRead()" style="font-size: 12px;">
          Marcar todas como leídas
        </button>
      }
    </div>
    <hr>
      <div style="overflow-y: auto; max-height: 500px;" #scrollContainer>
        @if (notifications.length == 0) {
          <h3 class="notificacion-h3">Sin Notificaciones</h3>
        }
        @for (notificacion of notifications; track notificacion) {
          <div [routerLink]="notificacion.uri" [queryParams]="notificacion.extraData" class="notificacion-button"
            [ngClass]="{'notificacion-leida': notificacion.banLeida}" (click)="markAsRead(notificacion)">
            <div>
              <div class="notificacion-fecha-container">
                <mat-icon class="kobra-icon" style="padding-right: 5px;">
                  {{ notificacion.tipoNotificacion === 'DOWNLOAD' ? 'download' : (notificacion.tipoNotificacion === 'ALERT' ?
                  'warning' : 'info') }}
                </mat-icon>
                <span style="width: 100% !important;">{{ notificacion.mensaje }}</span>
              </div>
              <div class="notificacion-fecha-container">
                <span class="notificacion-fecha">{{ notificacion.date }}</span>
                @if (hasIdDescarga(notificacion.extraData)) {
                  <a class="sombreado-link" style="padding: 5px;  font-size: 12px; margin-left: 5px; "
                    (click)="downloadFile(notificacion, $event)">Descargar
                  archivo</a>
                }
              </div>
            </div>
          </div>
        }
      </div>

    </mat-menu>

    <mat-menu #menuApps="matMenu" class="apps-grid-menu">
      <div class="apps-grid">
        <a mat-menu-item href="https://canva.com" target="_blank">
          <img src="assets/images/icon_Canva.png" alt="Canva" class="app-icon">
          <span>Canva</span>
        </a>
        <a mat-menu-item href="https://calificacionesia.kobra.red/login" target="_blank">
          <img src="assets/images/icon_calidad_ia.png" alt="Calificación IA" class="app-icon">
          <span>Calificación IA</span>
        </a>
        <a mat-menu-item href="https://callcenter.kobra.red" target="_blank">
          <img src="assets/images/icon_callcenter.png" alt="Callcenter" class="app-icon">
          <span>Callcenter</span>
        </a>
        <a mat-menu-item href="https://chatwoot.kobra.red" target="_blank">
          <img src="assets/images/icon_chatwoot.png" alt="Chatwoot" class="app-icon">
          <span>Chatwoot</span>
        </a>
        <a mat-menu-item href="https://discord.com/channels/@me" target="_blank">
          <img src="assets/images/icon_discord.png" alt="Discord" class="app-icon">
          <span>Discord</span>
        </a>
        <a mat-menu-item href="https://mail.google.com/" target="_blank">
          <img src="assets/images/icon_gmail.png" alt="Gmail" class="app-icon">
          <span>Gmail</span>
        </a>
        <a mat-menu-item (click)="abrirCRM()">
          <img src="assets/images/icon_crm.png" alt="CRM" class="app-icon">
          <span>CRM</span>
        </a>
        <a mat-menu-item href="https://app.powerbi.com/links/XTJDIozD2Z?ctid=4f2bbbcf-cc94-42ec-80fb-61724df56659&pbi_source=linkShare" target="_blank">
          <img src="assets/images/icon_power_bi.png" alt="Power BI" class="app-icon">
          <span>Power BI</span>
        </a>
        <a mat-menu-item href="https://kobra.pipedrive.com/" target="_blank">
          <img src="assets/images/icon_pipedrive.png" alt="Pipedrive" class="app-icon">
          <span>Pipedrive</span>
        </a>
        <a mat-menu-item href="https://kobra.red" target="_blank">
          <img src="assets/images/icon_sitio_kobra.png" alt="Sitio web" class="app-icon">
          <span>Sitio web</span>
        </a>
        <a mat-menu-item href="https://id.atlassian.com/login?application=trello" target="_blank">
          <img src="assets/images/icon_trello.png" alt="Trello" class="app-icon">
          <span>Trello</span>
        </a>
        <a mat-menu-item (click)="abrirMicrolearning()">
          <img src="assets/images/icon_microlearning.png" alt="Microlearning" class="app-icon">
          <span>Microlearning</span>
        </a>
        <a mat-menu-item (click)="abrirKobraCoin()">
          <img src="assets/images/icon_kobra_coin.png" alt="Kobra Coin" class="app-icon">
          <span>Kobra Coin</span>
        </a>
      </div>
    </mat-menu>
  </mat-toolbar>
  <router-outlet (deactivate)="filtrosServicios.asignarOpcion();"></router-outlet>
</mat-sidenav-content>
</mat-sidenav-container>

<!-- Super Ejecutivo: solo para super usuarios (kia-en-kobra-admin, RN1) y, mientras dura el piloto, solo para los usuarios piloto (super-ejecutivo-graficas, RN14). -->
@if (sessionData?.isSuperAdmin && idsUsuariosPilotoSuperEjecutivo.includes(sessionData.idUsuario)) {
  <app-super-ejecutivo-flotante [areaCentral]="areaCentral.nativeElement" [barraSuperior]="barraSuperior.nativeElement"></app-super-ejecutivo-flotante>
}
